import React from 'react';
import dateTimeHelper from '../../../../Helpers/datetimeHelper';
import StatusBarCardV2 from './StatusBarCardV2';

const StatusBarCard = ({ Tier, pricingDetail, UserCanMarkup, OverallTier }) => {
  if (!Tier || Tier.TierList.length === 0) {
    return <div className='StatusBarCard' />;
  }
  Tier.Calculate();
  const isLoss = Number(Tier.MarkedUpRevenueTotal) - Number(Tier.TotalCosts) < 0;

  return (
    <div className='StatusBarCard'>
      <div>
        {Tier.PricingDetails.Status === 'Final' && (
          <div className='StatusBarCardFinal'>
            <i>{`Using Rates from ${dateTimeHelper.toYYYYsMMsDDWithIndefinite(pricingDetail.FinalizedOn)} UTC`}</i>
            <i>{`1 ${pricingDetail.CurrencyCode} = ${parseFloat(1 / pricingDetail.FinalizedRate).toFixed(5)} USD`}</i>
          </div>
        )}
      </div>

      <div className='StatusBarCardGrid'>
        <div className='StatusBarCardGridRow'>
          <div className='StatusBarCardGridCell StatusBarCardValues'>
            <i><span className='fl'>Total Revenue</span><span className='fv'>{Tier.RevenueTotal}</span></i>
          </div>
          <div className='StatusBarCardGridCell StatusBarCardValues'>
            <i className={isLoss ? 'neg' : ''}><span className='fl'>Total Costs</span><span className='fv'>{Tier.CostTotal}<small>{Tier.CostPct}</small></span></i>
          </div>
          <div className='StatusBarCardGridCell StatusBarCardValues'>
            <i className={isLoss ? 'neg' : 'pos'}><span className='fl'>Net Revenue</span><span className='fv'>{Tier.NetRevenueTotal}<small>{Tier.RevenuePct}</small></span></i>
          </div>
        </div>
        {UserCanMarkup && (
          <div className='StatusBarCardGridRow'>
            <div className='StatusBarCardGridCell StatusBarCardValues'>
              <i><span className='fl'>Fieldwork Revenue</span><span className='fv'>{Tier.RevenueFWTotal}</span></i>
            </div>
            <div className='StatusBarCardGridCell StatusBarCardValues'>
              <i><span className='fl'>Fieldwork Costs</span><span className='fv'>{Tier.CostFWTotal}<small>{Tier.CostFWPct}</small></span></i>
            </div>
            <div className='StatusBarCardGridCell StatusBarCardValues'>
              <i><span className='fl'>Net Fieldwork</span><span className='fv'>{Tier.NetRevenueFWTotal}<small>{Tier.NetRevenueFWPct}</small></span></i>
            </div>
          </div>
        )}
      </div>

      <div className='StatusBarCardFinal' />
      <StatusBarCardV2
        Tier={Tier}
        pricingDetail={pricingDetail}
        UserCanMarkup={UserCanMarkup}
        OverallTier={OverallTier}
      />
    </div>
  );
};

export default StatusBarCard;
